import { feedbackDetailAction } from "../Slice/feedback-slice";
export const setFeedbackId = (payload) => {
  return (dispatch) => {
    console.log(payload);
    dispatch(feedbackDetailAction.setFeedbackId({ feedbackId: payload }));
  };
};
